import { createIcon } from '../icon'
import ResetIcon from '../svg/ResetIcon'

export const ResetIconDefault = createIcon(ResetIcon)
